import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ManageTerritory.css';
import { useSelector } from 'react-redux';
import Storage from '../../../services/Storage';
import { DashBoardTitle } from '../../../Components/Title';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import { Col, Container, Form, FormGroup, Label, Modal, ModalBody, Row, Table } from 'reactstrap';
import { AddUserButton, CommonButton, FilterButton, SearchInput, SingleSelect, UserInput } from '../../../Components/CommonComponents';
import lodash from 'lodash';
import ModalService from '../../../services/ModalService';
import { addTerritory, getAllTerritories, getStateHeadTMById } from '../../../constants/apiCalls';
import { handleErrorMessage } from '../../../utils/utils';
import excelImg from '../../../images/excel.png';
import closeImg from './../../../images/modalclose.png';
import { messages } from '../../../utils/constant-messages';
import Pagination from "../../../Components/Pagination/Pagination";
import DateService from '../../../services/DateService';
import { dateFormat } from '../../../constants/dateFormat';
import { Permissions } from '../../../constants/Permissions';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';

const ManageTerritory = () => {

    const navigate = useNavigate();
    const { permissionArr } = useSelector(state => state.UserGetReducer)
    const localPermission = permissionArr;
    useEffect(() => {
        if (!localPermission.includes(Permissions.ADMIN_MANAGE_TERRITORIES)) {
            navigate('/');
        }
    }, [...localPermission])

    let userInfo = Storage.getUserInfoDetail();
    let loginId = userInfo ? userInfo.id : null;

    let pageNo = useMemo(() => Storage.getManageTerritoryPage(), [Storage.getManageTerritoryPage()]);

    const [isLoading, setIsloading] = useState(false);
    const [isModalLoading, setIsModalLoading] = useState(false);

    const [count, setCount] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [page, setPage] = useState(Number(pageNo) ? Number(pageNo) : 1);
    const [pageSize, setPageSize] = useState(10);

    const [searchQuery, setSearchQuery] = useState('');
    const [userQuery, setUserQuery] = useState('');

    const [filterbtnActive, setFilterBtnActive] = useState(false);

    const [stateData, setStateData] = useState([]);

    // Filter Modal
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [stateVal, setStateVal] = useState('');
    const [stateId, setStateId] = useState('');

    // Add Territory Modal
    const [addTerritoryModal, setAddTerritoryModal] = useState('');
    const addTerritoryInitState = { territoryName: '', stateTerVal: '' };
    const [addTerritoryData, setAddTerritoryData] = useState(addTerritoryInitState);

    const [tableData, setTableData] = useState([]);

    const sendQuery = (query) => {
        setSearchQuery(query);
    };
    const delayedQuery = useCallback(
        lodash.debounce((q) => sendQuery(q), 1000),
        []
    );

    useEffect(() => {
        setIsloading(true)
        getTerritoryData()
    }, [searchQuery, page, pageSize, stateId])

    const getTerritoryData = () => {
        let payload = {
            q: searchQuery,
            page: page || 1,
            pagesize: pageSize || 10,
            // role_id: roleId || '',
            state_id: stateId || '',
            is_download: false,
        }
        setIsloading(true);
        getAllTerritories((res) => {
            const { data, success, error } = res;
            if (success === true) {
                if (data && data.territories) {
                    setTableData(data.territories);
                } else {
                    setTableData([]);
                }
                let count = Number(data.total_records);
                setCount(count);
                let totalPages = Math.ceil(count / pageSize);
                setTotalPages(totalPages);
                setIsloading(false);
            } else if (success === false || success === 'undefined') {
                ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
                setIsloading(false);
            }
            setIsloading(false);
        }, payload);
    }

    const getStateList = () => {
        let payload = {
            id: loginId,
        }
        getStateHeadTMById((res) => {
            const { data, success, error } = res;
            if (success === true) {
                if (data && data.length > 0 && data[0].state && data[0].state.length > 0) {
                    setStateData(data[0].state)
                } else {
                    setStateData([])
                }
                setIsloading(false);
            } else if (success === false || success === 'undefined') {
                ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
                setIsloading(false);
            }
            setIsloading(false);
        }, payload);
    };

    // search Functionality
    const handleSearchChange = (e) => {
        let q = e.target.value;
        delayedQuery(q);
        setUserQuery(q);
        if (q) {
            setPage(1);
        } else {
            setPage(Number(pageNo));
        }
    };

    // Add Territory
    const handleAddTerritory = () => {
        getStateList();
        setAddTerritoryData(addTerritoryInitState);
        setAddTerritoryModal(!addTerritoryModal)
    }

    const handleChangeAddTerritory = (e, inputName) => {
        const { name, value } = e.target;
        setAddTerritoryData({ ...addTerritoryData, [name]: value })
    }

    // Add Territory Modal Submit Territory
    const handleTerritorySubmit = (e) => {
        e.preventDefault();
        let payload = {
            name: addTerritoryData.territoryName || '',
            state_id: addTerritoryData.stateTerVal || '',
        }
        setIsloading(false);
        setIsModalLoading(true);
        addTerritory((res) => {
            const { success, message, error } = res;
            if (success === true) {
                ModalService.openAlert('', message, 'success');
                setPage(1);
                Storage.setManageTerritoryPage(1);
                setIsloading(false);
                setIsModalLoading(false);
                setAddTerritoryModal(false);
                if (filterbtnActive) {
                    getTerritoryData();
                }
            } else if (success === false || success === 'undefined') {
                ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
            }
            setIsloading(false);
            setIsModalLoading(false);
        }, payload);

    }

    const handleFilterBtnClick = () => {
        getStateList();
        setShowFilterModal(!showFilterModal);
        if (!filterbtnActive) {
            setStateVal('');
            setStateId('');
        }
    };

    const handleChangeState = (e) => {
        setStateVal(e.target.value);
    };

    const handleResetFilter = () => {
        setStateVal('');
        setStateId('');
        setShowFilterModal(false);
        setFilterBtnActive(false);
        setPage(1);
        Storage.setManageTerritoryPage(1);
    };

    const handleApplyFilter = (e) => {
        e.preventDefault();
        if (stateVal) {
            setStateId(stateVal);
            setFilterBtnActive(true);
            setPage(1);
            Storage.setManageTerritoryPage(1);
            setShowFilterModal(false);
        }
    };

    // pagination
    const handlePageChange = useCallback(
        (page) => {
            setPage(page);
            Storage.setManageTerritoryPage(Number(page));
        },
        [page, pageSize]
    );

    const handleInputChange = useCallback(
        (e) => {
            let pageSize = parseInt(e.target.value);
            setPageSize(pageSize);
            setPage(1);
        },
        [page, pageSize]
    );

    // Excel sheet
    const handleExcelSheet = (page, pageSize) => {
        let payload = {
            q: searchQuery,
            page: page || 1,
            pagesize: 100000,
            state_id: stateId || '',
            is_download: true,
        }
        getAllTerritories((res) => {
            const { data, success, error } = res;
            if (success === true) {
                window.open(data.file, '_blank');
                setIsloading(false);
            } else if (success === false || success === 'undefined') {
                ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
                setIsloading(false);
            }
            setIsloading(false);
        }, payload);
    };

    return (
        <>
            <AppHeader />
            <div className='app-main'>
                <AppSidebar />
                <div className='app-main__outer'>
                    <div className='app-main__inner rms-wrapper'>
                        <div id='manageTerritory'>
                            {isLoading && <CustomSpinner />}
                            <div className='pageWrapper'>
                                <Container fluid>
                                    <Row>
                                        <Col xs={12}>
                                            <div className='pageheader'>
                                                <DashBoardTitle dashBorardName='Manage Territories' className="lightTitle" />
                                            </div>
                                        </Col>
                                        <Col xs={12}>
                                            <div className='searchArea'>
                                                <div className='searchBlock'>
                                                    <SearchInput
                                                        InputProps={{
                                                            name: 'search',
                                                            placeholder:
                                                                'Search by Territory Name',
                                                        }}
                                                        onChange={handleSearchChange}
                                                        value={userQuery}
                                                    />
                                                    <FilterButton
                                                        onClick={handleFilterBtnClick}
                                                        className={
                                                            filterbtnActive ? 'activeFilterBtn' : 'inActiveFilterBtn'
                                                        }
                                                    />
                                                </div>
                                                <img src={excelImg} alt="excel" width={35} height={35} className="excelIcon mr-4" onClick={() => handleExcelSheet()} />
                                                <AddUserButton name="Add Territory" customClass="p-0" onClick={handleAddTerritory} />
                                            </div>
                                        </Col>
                                    </Row>
                                    {/* Table Area */}
                                    {tableData && tableData.length > 0 ? (
                                        <Row>
                                            <Col xs={12}>
                                                <div className='table-responsive dealerTable'>
                                                    <Table className='mb-0'>
                                                        <thead>
                                                            <tr>
                                                                <th className='text-left'>Territory name</th>
                                                                <th>State Name</th>
                                                                <th>Status</th>
                                                                <th>Created At</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {tableData.map((elem, index) => {
                                                                const { territory, state, is_active, created_at } = elem
                                                                return (
                                                                    <tr key={index}>
                                                                        <td className='text-left'>{territory || 'N/A'}</td>
                                                                        <td>{state || 'N/A'}</td>
                                                                        <td>{is_active ? 'Active' : 'Inactive'}</td>
                                                                        <td>{DateService.localDateOnly(created_at, dateFormat.DATE_FORMAT_3)} {DateService.localDateOnly(created_at, dateFormat.TIME_FORMAT_1)}
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </Col>
                                            <Col xs={12}>
                                                <div className='paginationWrapper'>
                                                    <span className='page-select-title'>Rows per page:</span>
                                                    &nbsp;&nbsp;
                                                    <select
                                                        className='form-control rows-per-page-select'
                                                        name='pageSize'
                                                        value={pageSize}
                                                        onChange={(e) => handleInputChange(e)}
                                                    >
                                                        <option key='5' value='5'>
                                                            5 Rows
                                                        </option>
                                                        <option key='10' value='10'>
                                                            10 Rows
                                                        </option>
                                                        <option key='15' value='15'>
                                                            15 Rows
                                                        </option>
                                                        <option key='20' value='25'>
                                                            25 Rows
                                                        </option>
                                                        <option key='25' value='30'>
                                                            30 Rows
                                                        </option>
                                                        <option key='30' value='50'>
                                                            50 Rows
                                                        </option>
                                                    </select>
                                                    &nbsp;&nbsp;
                                                    <div className='pageList'>
                                                        <Pagination
                                                            margin={2}
                                                            page={page}
                                                            count={parseInt(totalPages)}
                                                            pageSize={pageSize}
                                                            totalRecords={parseInt(count)}
                                                            onPageChange={handlePageChange}
                                                        ></Pagination>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    ) : (
                                        <Row>
                                            <Col xs={12}>
                                                {messages.COMMON.NO_RECORD_MATCH}
                                            </Col>
                                        </Row>
                                    )}
                                </Container>
                            </div>

                            {/* Filter Modal */}
                            <Modal
                                isOpen={showFilterModal}
                                toggle={() => setShowFilterModal(!showFilterModal)}
                                centered
                                className='territoryFilterModal'
                                id='territoryFilterModal'
                            >
                                {isModalLoading && <CustomSpinner />}
                                <ModalBody className='p-0'>
                                    <div className='ModalArea'>
                                        <Container>
                                            <Row>
                                                <Col xs={12}>
                                                    <div className='modalHeading'>
                                                        <div className='title'>Filter</div>
                                                        <div className='closeButton'>
                                                            <img
                                                                src={closeImg}
                                                                alt='close'
                                                                onClick={() => setShowFilterModal(!showFilterModal)}
                                                            />
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col xs={12}>
                                                    <Form onSubmit={handleApplyFilter}>
                                                        <FormGroup>
                                                            <Label className='common-input-label'>
                                                                State <span className='required'>*</span>
                                                            </Label>
                                                            <SingleSelect
                                                                id='stateVal'
                                                                required={true}
                                                                name='stateVal'
                                                                value={stateVal === null || stateVal === 'undefined' ? '' : stateVal}
                                                                onChange={(e) => handleChangeState(e)}
                                                                options={stateData}
                                                                label={'name'}
                                                                selectedValueKey={'state_id'}
                                                            />
                                                        </FormGroup>
                                                        <div className='btnGroup'>
                                                            <CommonButton
                                                                name='Reset'
                                                                onClick={handleResetFilter}
                                                                btnClass={'btnSecondary'}
                                                                type='button'
                                                            />
                                                            <CommonButton
                                                                name='Apply'
                                                                btnClass={'btnPrimary'}
                                                                type='submit'
                                                            />
                                                        </div>
                                                    </Form>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </ModalBody>
                            </Modal>

                            {/* Add Territoy Modal */}
                            <Modal
                                isOpen={addTerritoryModal}
                                toggle={() => setAddTerritoryModal(!addTerritoryModal)}
                                centered
                                className='addTerritoryModal'
                                id='addTerritoryModal'
                            >
                                {isModalLoading && <CustomSpinner />}
                                <ModalBody className='p-0'>
                                    <div className='ModalArea'>
                                        <Container>
                                            <Row>
                                                <Col xs={12}>
                                                    <div className='modalHeading'>
                                                        <div className='title'>Add Territory</div>
                                                        <div className='closeButton'>
                                                            <img
                                                                src={closeImg}
                                                                alt='close'
                                                                onClick={() => setAddTerritoryModal(!addTerritoryModal)}
                                                            />
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col xs={12}>
                                                    <Form onSubmit={handleTerritorySubmit}>
                                                        <FormGroup>
                                                            <Label className='common-input-label'>
                                                                Territory Name <span className='required'>*</span>
                                                            </Label>
                                                            <UserInput
                                                                required={true}
                                                                type='text'
                                                                name='territoryName'
                                                                id='territoryName'
                                                                placeholder='Type Here'
                                                                // value="vibha"
                                                                onChange={(e) => handleChangeAddTerritory(e, 'territoryName')}
                                                                value={addTerritoryData.territoryName === null || addTerritoryData.territoryName === 'undefined' ? '' : addTerritoryData.territoryName}
                                                            />
                                                        </FormGroup>
                                                        <FormGroup>
                                                            <Label className='common-input-label'>
                                                                State <span className='required'>*</span>
                                                            </Label>
                                                            <SingleSelect
                                                                id='stateTerVal'
                                                                required={true}
                                                                name='stateTerVal'
                                                                value={addTerritoryData.stateTerVal === null || addTerritoryData.stateTerVal === 'undefined' ? '' : addTerritoryData.stateTerVal}
                                                                onChange={(e) => handleChangeAddTerritory(e, 'stateTerVal')}
                                                                options={stateData}
                                                                label={'name'}
                                                                selectedValueKey={'state_id'}
                                                            />
                                                        </FormGroup>
                                                        <div className='btnGroup text-center'>
                                                            <CommonButton name={'Add'} btnClass={'btnPrimary'} type="submit" />
                                                        </div>
                                                    </Form>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </ModalBody>
                            </Modal>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ManageTerritory
